import {Component, ElementRef, OnInit, QueryList, ViewChildren} from '@angular/core';
import {AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ActivateService} from '../../activate/activate.service';
import {NotifierService} from '../../notifier/notifier.service';
import {NotificationType} from '../../notifier/notification-type.enum';
import {HttpEventType, HttpResponse} from '@angular/common/http';
import {forkJoin} from 'rxjs/observable/forkJoin';
import {ReportsService} from '../reports.service';
import {HeaderService} from "../../header/header.service";
import {DatePipe, Location} from '@angular/common';
import {Router} from "@angular/router";
import {CommonService} from "../../../common/common.service";
import {Set} from '../../../model/set';
import {Group} from "../../../model/group";
import {DemoList} from "./demo-list";

@Component({
  selector: 'pbc-add-reports',
  templateUrl: './add-reports.component.html',
  styleUrls: ['./add-reports.component.scss']
})
export class AddReportsComponent implements OnInit {


  filesUploaded: Array<any> = [];
  demoFileNames: Array<string> = [];

  collapse: boolean;

  addReportForm: FormGroup;

  dictProducts: Array<any> = [];

  dictInstitution: Array<any> = [];

  dictInterestArea: Array<any> = [];

  dictClient: Array<any> = [];

  dictPublicationFrequency : Array<any> = [];

  dictProductsSelected: Array<any> = [];

  dictInstitutionSelected: Array<any> = [];

  dictInterestAreaSelected: Array<any> = [];

  dictClientSelected: Array<any> = [];

  reportData: Array<any> = [];

  addReportSubmitted: boolean;

  dateInputFlag: boolean;

  selectedFiles: Array<any> = [];

  fileProgress: Array<any> = [];

  uploadedIds: Array<any> = [];

  //Lista plikow demo pobrana z serwisu
  demoFileList : Array<DemoList> = [];
  demoFileListForContentType : Array<string> = []

  // demoDisabled: boolean = false;

  sets : Array<Set>;
  groups : Array<Group>;
  titles : any;
  titlesForContentType : Array<Array<string>> = [];

  private anyThematicsMarked : boolean = false;

  @ViewChildren("products") products: QueryList<ElementRef>;
  @ViewChildren("institute") institute: QueryList<ElementRef>;
  @ViewChildren("intrstArea") intrstArea: QueryList<ElementRef>;
  @ViewChildren("clientGrp") clientGrp: QueryList<ElementRef>;
  @ViewChildren("selectAllFiles") selectAllFiles: QueryList<ElementRef>;
  none: any;

  constructor(
    private _formBuilder: FormBuilder,
    private activateService: ActivateService,
    private datePipe : DatePipe,
    private headerService : HeaderService,
    private router : Router,
    private location : Location,
    private reportsService: ReportsService,
    private notifierService: NotifierService,
    private commonService : CommonService,
    private elem: ElementRef
  ) {

      this.addReportForm = this._formBuilder.group({
        uploadFilesForms: this._formBuilder.array([])
      });
    }

  reportsToDescribe() : number {
    return this.filesUploaded.length;
  }

  ngOnInit() {
    this.headerService.hideLoginRegisterButtons();
    this.uploadedIds = [];

    forkJoin(
      this.activateService.getDictProduct(),
      this.commonService.getInstitutionDictionary(),
      this.activateService.getDictInterestArea(),
      this.activateService.getDictClient(),
      this.commonService.getContentTypeDictionary(),
      this.commonService.getFrequencyDictionary(),
      this.reportsService.getSets('name ASC'),
      this.commonService.getGroupList('name ASC'),
      this.reportsService.getDemoList(),
      this.reportsService.getTitleList()
    ).subscribe(([dictProductResponse, dictInstitutionResponse, dictInterestAreaResponse, dictClientResponse, dictContentTypeResponse, dictPublicationFrequencyResponse, sets, groups, demos, titles]) => {
        this.dictProducts = dictProductResponse;
        this.dictInstitution = dictInstitutionResponse;
        this.dictInterestArea = dictInterestAreaResponse;
        this.dictClient = dictClientResponse;
        this.reportData = dictContentTypeResponse;
        this.dictPublicationFrequency = dictPublicationFrequencyResponse;
        this.sets = sets.record;
        this.groups = groups.record;
        this.demoFileList = demos.record;
        this.titles = titles.record;
      },
      error => {
        console.log(error);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, 'Błąd przy pobieraniu danych');
      });
  }

  static validateThematics (formControl: AbstractControl) : {[key: string] : boolean} {
    let markedCount : number = 0;

    formControl.value.dictAreaArray.map((checked : boolean)=>{
      if (checked) markedCount ++
    });
    formControl.value.dictClientArray.map((checked : boolean) => {
      if (checked) markedCount ++;
    });
    formControl.value.dictInstitutionArray.map((checked : boolean) => {
      if (checked) markedCount++;
    });
    formControl.value.dictProductArray.map((checked : boolean) => {
      if (checked) markedCount++;
    });
    formControl.value.dictPublicationFrequencyArray.map((checked : boolean) => {
      if (checked) markedCount++;
    });

    if (markedCount === 0) {
      return {thematicsNotChecked: true};
    }

    return null;
  }
  
  uploadFiles(event: any): void {
    let requestArray = [];
    let fileUploadedDetials = [];
    for (let i = 0; i < event.addedFiles.length; i++) {
      this.filesUploaded.push(event.addedFiles[i]);
      fileUploadedDetials.push(event.addedFiles[i]);
      this.titlesForContentType.push();
      requestArray.push(this.reportsService.uploadFile(fileUploadedDetials[i]));
      this.filesUploaded = this.filesUploaded.map(response => {
        response.isOpen = false;
        response.submitted = false;
        return response;
      });

      let control : FormArray = <FormArray>this.addReportForm.controls.uploadFilesForms;
      let dictProductCheckboxes = this.dictProducts.map(control => new FormControl(false));
      let groupsCheckBoxes = this.groups.map(control => new FormControl(false));
      let dictClientCheckboxes = this.dictClient.map(control => new FormControl(false));
      let dictInstitutionCheckboxes = this.dictInstitution.map(control => new FormControl(false));
      let dictAreaCheckboxes = this.dictInterestArea.map(control => new FormControl(false));
      let dictPublicationFrequencyCheckboxes = this.dictPublicationFrequency.map(control => new FormControl(false));

      let formGroup : FormGroup = this._formBuilder.group({
        title: ['', Validators.required],
        description: [],
        content_type: ['', Validators.required],
        demoFile: [''],
        set : ['', Validators.required],
        published: ['publishImmediately'],
        publishFrom: [],
        selectAllCheckbox: [],
        disableDemoCheckBox : [false],
        selectAllGroupsCheckBox :  [false],
        dictProductArray: new FormArray(dictProductCheckboxes),
        groupsArray : new FormArray(groupsCheckBoxes),
        dictClientArray: new FormArray(dictClientCheckboxes),
        dictInstitutionArray: new FormArray(dictInstitutionCheckboxes),
        dictAreaArray: new FormArray(dictAreaCheckboxes),
        dictPublicationFrequencyArray : new FormArray(dictPublicationFrequencyCheckboxes),
        titleSelected : ['']
      });
      formGroup.setValidators(AddReportsComponent.validateThematics);
      control.push(formGroup);
    }``

    forkJoin(requestArray).subscribe(results => {
      fileUploadedDetials = [];
      for (let i = 0; i < results.length; i++) {
        this.fileProgress.push(0);
        // @ts-ignore
        this.uploadedIds.push(results[i].record.id);
        this.demoFileNames.push(undefined);
        // @ts-ignore
        if (results[i].type === HttpEventType.UploadProgress) {
          // @ts-ignore
          const percentDone = Math.round(100 * results[i].loaded / results[i].total);
          this.fileProgress[i] = percentDone;
        } else if (results[i] instanceof HttpResponse) {
          this.fileProgress[i] = 100;
        }
      }
      if (this.uploadedIds.length > 0)
        this.filesUploaded[0].isOpen = true;
    });
    // let elements = this.elem.nativeElement.querySelectorAll('.reset-dropzone')[0];
    // elements.click();
  }

  formatBytes(bytes: any) {
    if (bytes == 0) {
      return '0 Bytes';
    }
    var unitMultiple = 1000;
    var unitNames = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    var unitChanges = Math.floor(Math.log(bytes) / Math.log(unitMultiple));
    return parseFloat((bytes / Math.pow(unitMultiple, unitChanges)).toFixed(1 || 0)) + ' ' + unitNames[unitChanges];
  }

  private checkThematicsMarked(fileIndex : number) : boolean {
    let markedCount : number = 0;
    //produkty
    this.addReportForm.value.uploadFilesForms[fileIndex].dictProductArray.map((checked : boolean) => {
      if (checked) markedCount++;
    });
    //instytucje
    this.addReportForm.value.uploadFilesForms[fileIndex].dictInstitutionArray.map((checked : boolean) => {
      if (checked) markedCount++;
    });
    //grupy klientow
    this.addReportForm.value.uploadFilesForms[fileIndex].dictClientArray.map((checked : boolean) => {
      if (checked) markedCount++;
    });
    //obszary
    this.addReportForm.value.uploadFilesForms[fileIndex].dictAreaArray.map((checked : boolean) => {
      if (checked) markedCount++;
    });
    //czestotliwosc
    this.addReportForm.value.uploadFilesForms[fileIndex].dictPublicationFrequencyArray.map((checked : boolean) => {
      if (checked) markedCount++;
    });

    if (markedCount > 0)
      return true;
    else
      return false;
  }

  UpdateReports(index: any, fileId: any): void {
    this.addReportSubmitted = true;
    let dataObject = {};
    let confirmationInformation : string = "";

    this.filesUploaded[index].submitted = true;

    if(this.addReportForm.get('uploadFilesForms')['controls'][index].valid){
      dataObject['id'] = fileId;
      dataObject['title'] = this.addReportForm.value.uploadFilesForms[index].title;
      if(this.addReportForm.value.uploadFilesForms[index].description){
        dataObject['description'] = this.addReportForm.value.uploadFilesForms[index].description;
      }
      dataObject['content_type'] = this.addReportForm.value.uploadFilesForms[index].content_type;
      dataObject['sets'] = [];
      dataObject['sets'].push(this.addReportForm.value.uploadFilesForms[index].set);

      if(this.filesUploaded[index].demoDisabled !== undefined){
        dataObject['demoDisabled'] = (this.filesUploaded[index].demoDisabled).toString();
      } else {
        dataObject['demoDisabled'] = 'false';
      }
      dataObject['demoFileName'] = this.addReportForm.value.uploadFilesForms[index].demoFile;
      dataObject['repositoryDemoFileName'] = this.addReportForm.value.uploadFilesForms[index].demoFile;

      if(this.addReportForm.value.uploadFilesForms[index].published === 'publishImmediately'){
        confirmationInformation = 'Raport "'.concat(dataObject['title'], '" został opublikowany');
        dataObject['published'] = 'true';
        dataObject['publishFrom'] = new Date();
      } else if(this.addReportForm.value.uploadFilesForms[index].published === 'postponePublications'){
        confirmationInformation = 'Raport "'.concat(dataObject['title'], '" został dodany, ale jego publikacja została odłożona');
        dataObject['published'] = 'false';
      } else{
        dataObject['published'] = 'false';
        confirmationInformation = 'Publikacja raportu "'.concat(dataObject['title'], '" została zaplanowana na ');
        dataObject['publishFrom'] = this.addReportForm.value.uploadFilesForms[index].publishFrom ? new Date(this.addReportForm.value.uploadFilesForms[index].publishFrom.year,
          this.addReportForm.value.uploadFilesForms[index].publishFrom.month - 1,
          this.addReportForm.value.uploadFilesForms[index].publishFrom.day) : null;
        confirmationInformation = 'Publikacja raportu "'.concat(dataObject['title'], '" została zaplanowana na ',
          this.datePipe.transform(dataObject['publishFrom'], 'dd.MM.yyyy'), 'r.');
      }

      //Wyłączenie raportu z pokazywania w grupach
      const excluded_from_groups = this.addReportForm.value.uploadFilesForms[index].groupsArray.map(
        (checked : boolean, index : number) =>  checked ? this.groups[index].id : null
      ).filter((value : number) => value != null);
      if (excluded_from_groups && excluded_from_groups.length >0 )
        dataObject['excluded_from_groups'] = excluded_from_groups;
      else
        dataObject['excluded_from_groups'] = [];

      const selectedproducts = this.addReportForm.value.uploadFilesForms[index].dictProductArray.map(
        (checked: any, index: any) => checked ? this.dictProducts[index].id : null
      ).filter((value: any) => value !== null);
        if(selectedproducts && selectedproducts.length >0){
          dataObject['thematics_products'] = selectedproducts;
        }
      const selectedinstitution = this.addReportForm.value.uploadFilesForms[index].dictInstitutionArray.map(
          (checked: any, index: any) => checked ? this.dictInstitution[index].id : null
        ).filter((value: any) => value !== null);
          if(selectedinstitution && selectedinstitution.length >0){
            dataObject['thematics_institution'] = selectedinstitution;
          }
      const selectedclientgroups = this.addReportForm.value.uploadFilesForms[index].dictClientArray.map(
          (checked: any, index: any) => checked ? this.dictClient[index].id : null
        ).filter((value: any) => value !== null);
          if(selectedclientgroups && selectedclientgroups.length >0){
            dataObject['thematics_client_groups'] = selectedclientgroups;
          }
      const selectedarea = this.addReportForm.value.uploadFilesForms[index].dictAreaArray.map(
            (checked: any, index: any) => checked ? this.dictInterestArea[index].id : null
          ).filter((value: any) => value !== null);
            if(selectedarea && selectedarea.length >0){
              dataObject['thematics_area'] = selectedarea;
            }
      const selectedFrequency = this.addReportForm.value.uploadFilesForms[index].dictPublicationFrequencyArray.map(
        (checked: boolean, index : number) => checked ? this.dictPublicationFrequency[index].id : null
      ).filter((value : any) => value !== null);
            if (selectedFrequency && selectedFrequency.length > 0)
              dataObject['thematics_frequency'] = selectedFrequency;

      dataObject['uploadInProgress'] = 'false';
      this.reportsService.updateReport(dataObject).subscribe(response => {
        if (response.status == 'OK') {
          let control = <FormArray>this.addReportForm.controls.uploadFilesForms;
          control.removeAt(index);
          this.filesUploaded.splice(index, 1);
          this.uploadedIds.splice(index, 1);
          this.demoFileNames.splice(index, 1);
          if (this.filesUploaded.length > 0 && index < this.filesUploaded.length)
            this.filesUploaded[index].isOpen = true;

          this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION, confirmationInformation);
        }
      });
    }
  }

  removeDemoFileFromReport(reportPositionInArray : number) : void {
    this.reportsService.removeDemoFileFromReport(this.uploadedIds[reportPositionInArray]).subscribe(
        response=>{
          if (response.status !=1)
            this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
                "Wystąpił błąd. Nie udało się usunąć pliku demo z raportu");
          else {
            this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION, "Usunięto plik demo");
            this.demoFileNames[reportPositionInArray] = undefined;
          }
        },
        error=>{
          console.log(error);
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
              "Wystąpił błąd. Nie udało się usunąć pliku demo z raportu");
        }
    )
  }

  getDemoFile(event: any, reportPositionInArray: number): void {
    this.reportsService.uploadDemoFile(event.target.files[0], this.uploadedIds[reportPositionInArray]).subscribe(response => {
      if (response.record.length > 0)
        this.demoFileNames[reportPositionInArray]=response.record[0].demoFileName;
    });
  }
  
  deleteReports(index: any, fileId: any): void {

    let reportIds : Array<number> = [];
    reportIds.push(fileId);

    this.reportsService.deleteReports(reportIds).subscribe(response => {
      if (response.status == 1) {
        this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION, "Raport " + response.record[0].fileName + " został usuniety");
        let control = <FormArray>this.addReportForm.controls.uploadFilesForms;
        control.removeAt(index);
        this.filesUploaded.splice(index, 1);
        this.titlesForContentType.splice(index, 1);
        if (this.filesUploaded.length > 0)
          this.filesUploaded[index].isOpen = true;
        this.uploadedIds.splice(index, 1);
        this.demoFileNames.splice(index, 1);
      }
      this.selectedFiles = [];
    });
  }

  openFile(event: any) {
    let elements = this.elem.nativeElement.querySelectorAll('.file-input')[0];
    elements.click();
  }

  getUploadFilesFormsControls() {
    return (this.addReportForm.get('uploadFilesForms') as FormGroup).controls;
  }

  disableDemoCheckBoxClick(event : any, reportNumber:number) {
    let form = this.addReportForm.get('uploadFilesForms')['controls'][reportNumber];
    this.filesUploaded[reportNumber].demoDisabled = event.target.checked;
    if (!this.filesUploaded[reportNumber].demoDisabled) {
      this.addReportForm.value.uploadFilesForms[reportNumber].disableDemoCheckBox.setValue;
      form.controls['selectAllGroupsCheckBox'].reset(false);
      const groupsArrayCheckboxes = this.groups.map(control => new FormControl(false));
      form.setControl('groupsArray',this._formBuilder.array(groupsArrayCheckboxes));
    }
  }

  selectAllGroupsCheckboxesClick(event : any, reportNumber : number) {
    let form = this.addReportForm.get('uploadFilesForms')['controls'][reportNumber];
    const groupsArrayCheckboxes = this.groups.map(control => new FormControl(event.target.checked));
    form.setControl('groupsArray',this._formBuilder.array(groupsArrayCheckboxes));
  }

  allGroupsMarked(reportNumber : number) : boolean {
    let groupsChecked = this.addReportForm.value.uploadFilesForms[reportNumber].groupsArray.map(
      (checked: boolean, index: number) => checked ? this.groups[index].id : null);
    let groupsCheckedLength = groupsChecked.filter((value : any) => value !==null).length;

    return (groupsCheckedLength === this.groups.length);
  }

  groupCheckboxClick(event : any, reportNumber : number) {
      let form = this.addReportForm.get('uploadFilesForms')['controls'][reportNumber];
      form.controls['selectAllGroupsCheckBox'].setValue(this.allGroupsMarked((reportNumber)));
  }

  selectAllCheckbox(event: any,index: any){
    let form = this.addReportForm.get('uploadFilesForms')['controls'][index];
    const dictProductCheckboxes = this.dictProducts.map(control => new FormControl(event.target.checked));
    const dictClientCheckboxes = this.dictClient.map(control => new FormControl(event.target.checked));
    const dictInstitutionCheckboxes = this.dictInstitution.map(control => new FormControl(event.target.checked));
    const dictAreaCheckboxes = this.dictInterestArea.map(control => new FormControl(event.target.checked));
    form.setControl('dictProductArray',this._formBuilder.array(dictProductCheckboxes));
    form.setControl('dictClientArray',this._formBuilder.array(dictClientCheckboxes));
    form.setControl('dictInstitutionArray',this._formBuilder.array(dictInstitutionCheckboxes));
    form.setControl('dictAreaArray',this._formBuilder.array(dictAreaCheckboxes));
  }

  validateCheckAll(event: any,index: any, j: any, formcontrolName: any){
    let form;
    if(index !== 0){
      form = this.addReportForm.controls['uploadFilesForms']['controls'][index];
      form.get(formcontrolName)['controls'][j].patchValue(event.target.checked);
    } else{
      form = this.addReportForm.controls['uploadFilesForms']['controls'][0];
      form.get(formcontrolName)['controls'][j].patchValue(event.target.checked);
    }
    
    const selectedproducts = this.addReportForm.value.uploadFilesForms[index].dictProductArray.map(
      (checked: any, index: any) => checked ? this.dictProducts[index].id : null
    ).filter((value: any) => value !== null).length;
    const selectedinstitution = this.addReportForm.value.uploadFilesForms[index].dictInstitutionArray.map(
      (checked: any, index: any) => checked ? this.dictInstitution[index].id : null
    ).filter((value: any) => value !== null).length;
    const selectedclientgroups = this.addReportForm.value.uploadFilesForms[index].dictClientArray.map(
      (checked: any, index: any) => checked ? this.dictClient[index].id : null
    ).filter((value: any) => value !== null).length;
    const selectedarea = this.addReportForm.value.uploadFilesForms[index].dictAreaArray.map(
      (checked: any, index: any) => checked ? this.dictInterestArea[index].id : null
    ).filter((value: any) => value !== null).length;
    const selectedPublicationFrequencies = this.addReportForm.value.uploadFilesForms[index].dictPublicationFrequencyArray.map(
      (checked : boolean, index : number) => checked ? this.dictPublicationFrequency[index].id : null)
      .filter((value : any) => value !==null).length;

    let totalChecked = selectedproducts + selectedinstitution + selectedclientgroups + selectedarea + selectedPublicationFrequencies ;

    if (totalChecked>0)
      this.anyThematicsMarked = true;
    else
      this.anyThematicsMarked = false;

    let totalApiChecked = this.dictProducts.length + this.dictInstitution.length + this.dictInterestArea.length + this.dictClient.length + this.dictPublicationFrequency.length;
    if(totalApiChecked !== totalChecked){
      form.patchValue({'selectAllCheckbox':false});
    } else{
      form.patchValue({'selectAllCheckbox':true});
    }
  }

  contentTypeChange(value : any, reportNumber : number) {
    let titleListNotChanged : boolean = true;
    for (let i = 0; i < this.titles.length; i++)
      if (this.titles[i].contentType === value) {
        this.titlesForContentType[reportNumber] = this.titles[i].titles;
        titleListNotChanged = false;
      }

    for (let i = 0; i < this.demoFileList.length; i++)
      if (this.demoFileList[i].contentTypeId === value)
        this.demoFileListForContentType = this.demoFileList[i].demoFiles;

    if (titleListNotChanged)
      this.titlesForContentType[reportNumber] = [];

    let formsWithReports : FormArray = <FormArray>this.addReportForm.controls.uploadFilesForms;
    if (formsWithReports.length > reportNumber)
      (formsWithReports.controls[reportNumber] as FormGroup).controls.titleSelected.setValue('');
  }

  titleChange(value: any, reportNumber : number) {
    let formsWithReports : FormArray = <FormArray>this.addReportForm.controls.uploadFilesForms;
    if (formsWithReports.length > reportNumber)
      (formsWithReports.controls[reportNumber] as FormGroup).controls.title.setValue(value);
  }
}
